document.addEventListener('DOMContentLoaded', function () {

  function toGermanQuotes(str) {
    str = str.replace(/"([^"]*)"/g, '„$1“');
    str = str.replace(/„([^“]*)"/g, '„$1“');
    return str;
  }

  function collectTextNodesAndBreaks(node, arr = []) {
    node.childNodes.forEach(child => {
      if (child.nodeType === Node.TEXT_NODE) {
        arr.push({type: 'text', node: child});
      } else if (child.nodeName === 'BR') {
        arr.push({type: 'br', node: child});
      } else {
        collectTextNodesAndBreaks(child, arr);
      }
    });
    return arr;
  }

  function replaceQuotesAcrossDOM(element) {
    const nodes = collectTextNodesAndBreaks(element);

    let text = '';
    nodes.forEach(n => {
      if (n.type === 'text') text += n.node.nodeValue;
      else if (n.type === 'br') text += '\uFFFF'; 
    });

    let replaced = toGermanQuotes(text);

    let parts = replaced.split('\uFFFF');
    let textNodeIndex = 0;
    for (let i = 0; i < parts.length; i++) {
      let part = parts[i];
      while (textNodeIndex < nodes.length && nodes[textNodeIndex].type !== 'text') {
        textNodeIndex++;
      }
      if (textNodeIndex < nodes.length) {
        let remaining = part;
        while (remaining.length > 0 && textNodeIndex < nodes.length && nodes[textNodeIndex].type === 'text') {
          let n = nodes[textNodeIndex].node;
          let len = n.nodeValue.length;
          n.nodeValue = remaining.slice(0, len);
          remaining = remaining.slice(len);
          textNodeIndex++;
        }
      }
    }
  }

  const elements = document.querySelectorAll('.forum-entries-overview .forum-entry, .thread-overview .thread-head, .thread-overview .post-entry');
  if (elements.length > 0) {
    elements.forEach(el => {
        console.log('test ALL');
      replaceQuotesAcrossDOM(el);
    });
  }
  
});


